import { render } from "./CoffeeOffIcon.vue?vue&type=template&id=725ab8bc"
import script from "./CoffeeOffIcon.vue?vue&type=script&lang=js"
export * from "./CoffeeOffIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__